<div
	class="flex px-7 no-scrollbar overflow-hidden overflow-x-auto"
	*ngIf="tabs$ | async as tabs"
>
	<div
		*ngFor="let matter of tabs; let i = index"
		class="relative cursor-pointer tab flex index-{{ i }}"
		[class.purchase]="matter.fileType === 'purchase'"
		[class.sale]="matter.fileType === 'sale'"
		[class.refinance]="matter.fileType === 'refinance'"
		[class.selected]="matter.id === selectedId"
		[class.pinned]="matter.pinned"
	>
		<span class="left-curve curve"></span>
		<span class="right-curve curve"></span>
		<div
			class="flex flex-1 gap-1 py-1 px-2 items-center overflow-hidden justify-between"
			(click)="goToFile(matter)"
			[matTooltip]="'#' + matter.number + ' - ' + matter.name"
			[testHook]="testHooks.GoToFileDiv"
		>
			<div class="flex truncate items-center overflow-hidden">
				<span class="file-number text-sm truncate font-bold"
					>#{{ matter.number }}</span
				>
				<span
					class="file-name truncate text-sm font-bold"
					*ngIf="!matter.pinned"
					>{{ matter.name }}</span
				>
			</div>
			<app-button
				*ngIf="!matter.pinned"
				size="small"
				btn="tertiary"
				[icon]="ICON.CLOSE"
				(click)="remove($event, matter.id, i)"
				[testHook]="testHooks.RemoveButton"
			></app-button>
			<app-button
				*ngIf="matter.pinned"
				size="small"
				btn="tertiary"
				[icon]="ICON.PIN"
				[iconStyle]="ICON_STYLE.SOLID"
				(click)="unpin($event, matter.id)"
				[tooltip]="Unpin"
				[testHook]="testHooks.UnpinButton"
			>
			</app-button>
		</div>
	</div>
</div>
